export const handleClickForKeyboard = (
  onClick?: ((e?: React.UIEvent) => void) | ((e: React.UIEvent) => void),
  options?: { keys?: string[] },
) => {
  if (!onClick) {
    return undefined;
  }

  const { keys = ["Enter", " "] } = options ?? {};

  return (e: React.KeyboardEvent) => {
    if (keys.includes(e.key)) {
      e.preventDefault();
      onClick(e);
    }
  };
};
